import { exportCsv } from "shared/utils/exportCsv"
import { buildClassSituationExportColumns } from "./classSituationExportSpec"

const pad2 = (n) => String(n).padStart(2, "0")

const todayStamp = () => {
  const d = new Date()
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
}

/**
 * Builds the Filters summary row shown as the first line of the CSV, from
 * the same filter state the page keeps (search box, top selects and the
 * "More Filters" popover selections).
 */
function buildFilterItems({ search, statusFilter, acsStatusFilter, selectedEc, filterData }) {
  return [
    {
      label: "Date Range",
      value: filterData?.fromDate ? `${filterData.fromDate} - ${filterData.toDate}` : "All",
    },
    { label: "Search", value: search || "All" },
    { label: "Status", value: statusFilter?.label ?? "All" },
    { label: "ACS Status", value: acsStatusFilter?.label ?? "All" },
    { label: "EC", value: selectedEc?.label ?? "All" },
    { label: "KOC", value: filterData?.koc?.label ?? "All" },
    { label: "Schedule Day", value: filterData?.schedule?.label ?? "All" },
    { label: "Level", value: filterData?.classLevel?.label ?? "All" },
    { label: "Teacher", value: filterData?.teacher?.label ?? "All" },
  ]
}

/**
 * Exports the Class Situation table + number block + active filters to a
 * CSV file, mirroring what's currently shown on screen (respecting Column
 * Visibility and filters) but with every group always expanded, so the CSV
 * always contains all sub-columns.
 */
export function exportClassSituationCsv({
  rows,
  visibleColumns,
  summaryGroups,
  tableSummaryItems,
  search,
  statusFilter,
  acsStatusFilter,
  selectedEc,
  filterData,
}) {
  const filterItems = buildFilterItems({
    search,
    statusFilter,
    acsStatusFilter,
    selectedEc,
    filterData,
  })

  const summaryItems = summaryGroups
    .flatMap((group) => group.cards)
    .map((card) => ({ label: card.title, value: card.value }))

  const columns = buildClassSituationExportColumns(visibleColumns)

  exportCsv({
    filename: `class-situation-${todayStamp()}.csv`,
    sections: [
      { type: "keyValueRow", label: "Filters", items: filterItems },
      { type: "spacer" },
      { type: "labelValueRows", items: summaryItems },
      { type: "spacer" },
      { type: "table", columns, rows: rows ?? [] },
      // Not yet a last row under the same columns as TableSituation's footer.
      // When that footer changes, update this block and classSituationExportSpec.js together.
      ...(tableSummaryItems?.length
        ? [
            { type: "spacer" },
            { type: "labelValueRows", items: tableSummaryItems },
          ]
        : []),
    ],
  })
}
